
let enabled = true;

      try {
        enabled = /(?:^|;\s)__vercel_toolbar=1(?:;|$)/.test(document.cookie);
      } catch (e) {
        enabled = false;
      }

if(enabled){
    var s=document.createElement('script');
    s.src='https://vercel.live/_next-live/feedback/feedback.js';
    s.setAttribute("data-explicit-opt-in","true");s.setAttribute("data-cookie-opt-in","true");
    s.setAttribute("data-deployment-id",process.env.NEXT_DEPLOYMENT_ID);
    ((document.head||document.documentElement).appendChild(s))
}